import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Healthy Kitchen</h3>
            <p className="text-sm">
              Serving healthy and delicious meals made with fresh, organic ingredients.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-brand-300">Home</Link></li>
              <li><Link to="/menu" className="hover:text-brand-300">Menu</Link></li>
              <li><Link to="/about" className="hover:text-brand-300">About</Link></li>
              <li><Link to="/contact" className="hover:text-brand-300">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-brand-300"><FaFacebook size={24} /></a>
              <a href="#" className="hover:text-brand-300"><FaInstagram size={24} /></a>
              <a href="#" className="hover:text-brand-300"><FaTwitter size={24} /></a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm">© {new Date().getFullYear()} AAP.NINJA – All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;